/**
 * @desc 修改订单支付单价数据
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrder.fixPrice.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/fixPrice`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
